export default "__VITE_ASSET__BUewFKCi__"